import { FontAwesome as Icon } from "@expo/vector-icons";
import React, { forwardRef, useState } from "react";
import { TextInput, TouchableOpacity, View } from "react-native";
import { useTranslation } from "react-i18next";
import { FormInput, FormInputProps } from "./FormInput";

export const FormPasswordInput = forwardRef<TextInput, FormInputProps>(
  ({ className = "", ...rest }, ref) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    return (
      <View className="relative w-full">
        <FormInput
          ref={ref}
          secureTextEntry={!visible}
          className={`pr-12 ${className}`}
          {...rest}
        />
        <TouchableOpacity
          onPress={() => setVisible((v) => !v)}
          accessibilityRole="button"
          accessibilityLabel={visible ? t("HIDE_PASSWORD") : t("SHOW_PASSWORD")}
          className="absolute right-0 top-0 bottom-0 justify-center items-center w-12"
        >
          <Icon name={visible ? "eye" : "eye-slash"} size={20} color="#9CA3AF" />
        </TouchableOpacity>
      </View>
    );
  },
);

FormPasswordInput.displayName = "FormPasswordInput";

export default FormPasswordInput;
